import { errorValidation } from './utils';

let buyCreditPhone = $('#buy_credit_phone');

/**
 * Init intlTelInput
 */
[buyCreditPhone].forEach(phoneInput => {
	phoneInput.inputmask({
		mask: 'V9{1,15}',
		definitions: {
			V: {
				// validator: '^[1-9][0-9]*$',
				validator: '^[0-9]+$',
			},
		},
		placeholder: '',
	});

	// Set the initial country code on page load
	let initialCountryCode = phoneInput.intlTelInput(
		'getSelectedCountryData',
	).dialCode;
	let countryCodeInput = phoneInput
		.closest('.input-wrapper')
		.find('.country-code');
	countryCodeInput.val(initialCountryCode);

	// On blur: validate
	phoneInput.focusout(function () {
		if ($.trim(phoneInput.val())) {
			if (phoneInput.intlTelInput('isValidNumber')) {
				console.log('isValidNumber');
				// Save country code
				countryCodeInput.val(initialCountryCode);
			} else {
				phoneInput.addClass('_error');
			}
		}
	});

	// On keydown: reset
	phoneInput.keydown(function () {
		phoneInput.removeClass('_error');
	});
});

/**
 * Add custom validation method
 */
$.validator.addMethod(
	'validateBuyCreditPhone',
	function (value, element) {
		return $(element).intlTelInput('isValidNumber');
	},
	window.translations.phoneInvalid,
);

/**
 * Validate forms
 */
(() => {
	// One Click
	$("form[name='buy_credit']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'buy_credit[months]': {
				required: true,
			},
			'buy_credit[interest]': {
				required: true,
			},
			'buy_credit[name]': {
				required: true,
			},
			'buy_credit[phone]': {
				required: true,
				// validateBuyCreditPhone: true,
			},
			'buy_credit[address]': {
				required: true,
			},
			'buy_credit[city]': {
				required: true,
			},
			'buy_credit[terms]': {
				required: true,
			},
		},
		messages: {
			'buy_credit[months]': {
				required: window.translations.required,
			},
			'buy_credit[interest]': {
				required: window.translations.required,
			},
			'buy_credit[name]': {
				required: window.translations.required,
			},
			'buy_credit[phone]': {
				required: window.translations.required,
			},
			'buy_credit[address]': {
				required: window.translations.required,
			},
			'buy_credit[city]': {
				required: window.translations.required,
			},
			'buy_credit[terms]': {
				required: window.translations.required,
			},
		},
		submitHandler: async (form, e) => {
			if (e) e.preventDefault();

			// Disable submit button
			$(form).find('button[type="submit"]').prop('disabled', true);
			$(form).find('button[type="submit"]').addClass('disabled');

			if (form.hasAttribute('data-recaptcha')) {
				const action = form.getAttribute('data-recaptcha');
				const success = await window.add_recaptcha_token(form, action);

				if (success) {
					console.log('✅ reCAPTCHA token added successfully');
					form.submit();
				} else {
					console.log('❌ reCAPTCHA failed');
				}
			} else {
				console.log('🔄 Form validation passed');
				form.submit();
			}
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();
